/***************************************************
 * Created by gongyanyu on 2023/3/28 17:43. *
 ***************************************************/ import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { extendObservable, observable } from "mobx";
export function initDataRef(source, key, target, targetKey, defaultValue) {
    if (targetKey in target) {
        var _target, _targetKey;
        var _;
        (_ = (_target = target)[_targetKey = targetKey]) !== null && _ !== void 0 ? _ : _target[_targetKey] = defaultValue;
    } else {
        extendObservable(target, _define_property({}, targetKey, defaultValue), _define_property({}, targetKey, observable));
    }
    delete source[key];
    Object.defineProperty(source, key, {
        configurable: true,
        get: function() {
            return target[targetKey];
        },
        set: function(value) {
            return void (target[targetKey] = value);
        }
    });
}
export function isRefCreator(fn) {
    return typeof fn === "function" && fn["$$DataRefer"] === true;
}
export function createDataRef(target, targetKey, defaultValue) {
    var fn = function fn(source, key) {
        return initDataRef(source, key, target, targetKey, defaultValue);
    };
    fn.$$DataRefer = true;
    return fn;
}
